export default __webpack_public_path__ + "static/media/2001.6d07574c.png";